// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Pager Number List Component */
:host(ids-pager-number-list) {
  box-sizing: border-box;
  flex-basis: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-align: center;
}

ids-button {
  vertical-align: initial;
}

ids-button::part(button) {
  max-width: var(--ids-space-xl);
  padding: 6px var(--ids-space-xs);
}

ids-button:not([selected]):not([disabled])::part(button) {
  color: var(--ids-hyperlink-color-text-default);
}

ids-button[selected]::part(button) {
  font-weight: var(--ids-font-weight-semibold);
}

ids-button:not([selected]):hover {
  border: none;
  border-bottom: 1px solid var(--ids-color-border-focus);
}

.divider {
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-pager/ids-pager-number-list.scss"],"names":[],"mappings":"AAAA,oCAAA;AACA;EACE,sBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,8BAAA;EACA,gCAAA;AACF;;AAEA;EACE,8CAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EACE,YAAA;EACA,sDAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":["/* Ids Pager Number List Component */\n:host(ids-pager-number-list) {\n  box-sizing: border-box;\n  flex-basis: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  text-align: center;\n}\n\nids-button {\n  vertical-align: initial;\n}\n\nids-button::part(button) {\n  max-width: var(--ids-space-xl);\n  padding: 6px var(--ids-space-xs);\n}\n\nids-button:not([selected]):not([disabled])::part(button) {\n  color: var(--ids-hyperlink-color-text-default);\n}\n\nids-button[selected]::part(button) {\n  font-weight: var(--ids-font-weight-semibold);\n}\n\nids-button:not([selected]):hover {\n  border: none;\n  border-bottom: 1px solid var(--ids-color-border-focus);\n}\n\n.divider {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
